import { useEffect, useState } from "react";
import axios from "axios";
import { ExternalLink } from "lucide-react";
import BlockShell from "./BlockShell";
import { API } from "../../App";

const DontMissGridBlock = ({ block, festival }) => {
  const cfg = block.config || {};
  const [spots, setSpots] = useState([]);
  const slug = cfg.festival_slug || festival?.slug;

  useEffect(() => {
    axios.get(`${API}/dont-miss-spots`).then((r) => {
      const list = r.data.spots || [];
      setSpots(slug ? list.filter((s) => s.festival === slug || !s.festival) : list);
    }).catch(() => setSpots([]));
  }, [slug]);

  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-8" data-testid="fest-dontmiss">
      <BlockShell block={block} accent="#E76F51">
        <div className="grid md:grid-cols-2 gap-4">
          {spots.map((s) => (
            <div key={s.spot_id} className="bg-white rounded-xl border border-[#E2E0DC] shadow-sm overflow-hidden">
              <div className="flex items-start gap-3 p-4">
                {s.logo && (
                  <img src={s.logo} alt="" className="w-14 h-14 rounded-full border shadow" />
                )}
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-[#1A1A1A]">{s.name}</h3>
                  {s.tagline && <p className="text-sm italic text-[#E76F51]">{s.tagline}</p>}
                  {s.description && <p className="text-sm text-[#3a3a3a] mt-1">{s.description}</p>}
                  {s.location_note && <p className="text-xs text-[#5C5C5C] mt-1">{s.location_note}</p>}
                  {(s.links || []).map((l) => (
                    <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-xs text-[#2E5C55] underline mt-1">
                      {l.label} <ExternalLink className="h-3 w-3" />
                    </a>
                  ))}
                </div>
              </div>
              {(s.images || []).length > 0 && (
                <div className="flex gap-1 px-4 pb-4 overflow-x-auto">
                  {s.images.map((img) => (
                    <img key={img} src={img} alt="" className="h-24 w-24 rounded-md object-cover border shrink-0" />
                  ))}
                </div>
              )}
            </div>
          ))}
          {spots.length === 0 && (
            <p className="text-sm italic text-[#5C5C5C]">No Don&apos;t Miss spots tagged to this festival yet.</p>
          )}
        </div>
      </BlockShell>
    </section>
  );
};

export default DontMissGridBlock;
